<!-- Breadcrumb for application -->
<div class="container">
  <nav aria-label="breadcrumb" class="breadCust">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/corporate/home">Home</a></li>
      <li class="breadcrumb-item active" aria-current="page">Marketing Tool</li>
    </ol>
  </nav>
</div>



<div class="container mt-4 theme-fa-icon">
  <fieldset class="scheduler-border">

    <div class="row">
    <div class="col-xl-4  col-md-6">
      <button class="cbtn mt-1" routerLink="/corporate/cb-email-templates">
        <i class="bi bi-layout-sidebar blue-lt-icon" aria-hidden="true"></i>Email Builder
      </button>
    </div>

    <div class="col-xl-4  col-md-6" >
      <button class="cbtn mt-1" routerLink="/corporate/journey-list">
        <i class="fa fa-newspaper-o red-dr-icon" aria-hidden="true"></i>Journey Builder
      </button>
    </div>

    <div class="col-xl-4  col-md-6" >
      <button class="cbtn mt-1" routerLink="/corporate/prompt-list">
        <i class="fa fa-newspaper-o red-dr-icon" aria-hidden="true"></i>AI Prompt's
      </button>
    </div>

    </div>
  </fieldset>
</div>


